const WITH_SELECTED_FILTERS = ' с учетом выбранных фильтров';
const PROCESSED_TASK_PREFIX = 'Количество заданий со статусом "Обработано"';
const PROCESSED_CALL_PREFIX =
  'Количество звонков в рамках заданий со статусом "Обработано"';
const TARGET_RESULTS =
  '"Подтверждено", "Отказ", "Запрос на перенос", "Передано оператору", "Лист ожидания"';
const TECHNICAL_RESULTS =
  '"Не идентифицирован", "Не удалось дозвониться", "Отменено клиникой", "Перенесено клиникой"';

const processedWithResult = (result: string) =>
  `${PROCESSED_TASK_PREFIX} и результатом "${result}"${WITH_SELECTED_FILTERS}`;

const processedWithResults = (results: string) =>
  `${PROCESSED_TASK_PREFIX} и одним из результатов: ${results}${WITH_SELECTED_FILTERS}`;

const resultByAttemptCount = (attemptDescription: string) =>
  `${PROCESSED_TASK_PREFIX} и ${attemptDescription} в рамках задания${WITH_SELECTED_FILTERS}`;

const targetResultByAttemptCount = (attemptDescription: string) =>
  `${PROCESSED_TASK_PREFIX}, одним из результатов: ${TARGET_RESULTS} и ${attemptDescription} в рамках задания${WITH_SELECTED_FILTERS}`;

const technicalResultByAttemptCount = (attemptDescription: string) =>
  `${PROCESSED_TASK_PREFIX}, одним из результатов: ${TECHNICAL_RESULTS} и ${attemptDescription} в рамках задания${WITH_SELECTED_FILTERS}`;

const callsByAttemptCount = (attemptDescription: string) =>
  `${PROCESSED_CALL_PREFIX} и ${attemptDescription} в рамках задания${WITH_SELECTED_FILTERS}`;

const targetCallsByAttemptCount = (attemptDescription: string) =>
  `${PROCESSED_CALL_PREFIX}, одним из результатов: ${TARGET_RESULTS} и ${attemptDescription} в рамках задания${WITH_SELECTED_FILTERS}`;

const technicalCallsByAttemptCount = (attemptDescription: string) =>
  `${PROCESSED_CALL_PREFIX}, одним из результатов: ${TECHNICAL_RESULTS} и ${attemptDescription} в рамках задания${WITH_SELECTED_FILTERS}`;

const callsWithResult = (result: string) =>
  `${PROCESSED_CALL_PREFIX} и результатом "${result}"${WITH_SELECTED_FILTERS}`;

const callsWithStatus = (status: string) =>
  `Количество звонков со статусом "${status}" в рамках заданий со статусом "Обработано" и результатом "Не удалось дозвониться"${WITH_SELECTED_FILTERS}`;

const failedCallWithLastStatus = (status: string) =>
  `${PROCESSED_TASK_PREFIX} и результатом "Не удалось дозвониться", где последний звонок завершился со статусом "${status}"${WITH_SELECTED_FILTERS}`;

const ONE_ATTEMPT = 'одним звонком';
const TWO_ATTEMPTS = 'двумя звонками';
const THREE_OR_MORE_ATTEMPTS = 'тремя и более звонками';

const OUTGOING_STATISTIC_TOOLTIPS: Readonly<Record<string, string>> = {
  'common-tasksCount':
    'Количество всех имеющихся в базе заданий с учетом выбранных фильтров',
  'common-processedTasksCount': `${PROCESSED_TASK_PREFIX}${WITH_SELECTED_FILTERS}`,
  'common-processedTasksAttemptCount': `Количество звонков, выполненных в рамках заданий со статусом "Обработано"${WITH_SELECTED_FILTERS}`,
  'common-inProcessingTasksCount': `Количество заданий со статусом "В обработке"${WITH_SELECTED_FILTERS}`,
  'common-notProcessedTasksCount': `Количество заданий со статусом "В очереди"${WITH_SELECTED_FILTERS}`,
  'common-blockedTasksCount': `Количество заданий со статусом "Черный список"${WITH_SELECTED_FILTERS}`,
  'efficiency-averageAttempts': `Соотношение количества заданий со статусом "Обработано" к количеству звонков в рамках этих заданий${WITH_SELECTED_FILTERS}`,
  'efficiency-oneAttemptTasksCount': resultByAttemptCount(ONE_ATTEMPT),
  'efficiency-oneAttemptTasksCount-target':
    targetResultByAttemptCount(ONE_ATTEMPT),
  'efficiency-oneAttemptTasksCount-technical':
    technicalResultByAttemptCount(ONE_ATTEMPT),
  'efficiency-twoAttemptTasksCount': resultByAttemptCount(TWO_ATTEMPTS),
  'efficiency-twoAttemptTasksCount-target':
    targetResultByAttemptCount(TWO_ATTEMPTS),
  'efficiency-twoAttemptTasksCount-technical':
    technicalResultByAttemptCount(TWO_ATTEMPTS),
  'efficiency-threeAndMoreAttemptTasksCount': resultByAttemptCount(
    THREE_OR_MORE_ATTEMPTS,
  ),
  'efficiency-threeAndMoreAttemptTasksCount-target': targetResultByAttemptCount(
    THREE_OR_MORE_ATTEMPTS,
  ),
  'efficiency-threeAndMoreAttemptTasksCount-technical':
    technicalResultByAttemptCount(THREE_OR_MORE_ATTEMPTS),
  'efficiency-noAttemptTasksCount': `${PROCESSED_TASK_PREFIX}, одним из результатов: "Отменено клиникой", "Перенесено клиникой" и отсутствием звонков в рамках задания${WITH_SELECTED_FILTERS}`,
  'efficiency-processedTasksAttemptCount': `Количество звонков, выполненных в рамках заданий со статусом "Обработано"${WITH_SELECTED_FILTERS}`,
  'efficiency-oneAttemptTasksAttemptCount': callsByAttemptCount(ONE_ATTEMPT),
  'efficiency-oneAttemptTasksAttemptCount-target':
    targetCallsByAttemptCount(ONE_ATTEMPT),
  'efficiency-oneAttemptTasksAttemptCount-technical':
    technicalCallsByAttemptCount('одним звонком'),
  'efficiency-twoAttemptTasksAttemptCount': callsByAttemptCount(TWO_ATTEMPTS),
  'efficiency-twoAttemptTasksAttemptCount-target':
    targetCallsByAttemptCount(TWO_ATTEMPTS),
  'efficiency-twoAttemptTasksAttemptCount-technical':
    technicalCallsByAttemptCount(TWO_ATTEMPTS),
  'efficiency-threeAndMoreAttemptTasksAttemptCount': callsByAttemptCount(
    THREE_OR_MORE_ATTEMPTS,
  ),
  'efficiency-threeAndMoreAttemptTasksAttemptCount-target':
    targetCallsByAttemptCount(THREE_OR_MORE_ATTEMPTS),
  'efficiency-threeAndMoreAttemptTasksAttemptCount-technical':
    technicalCallsByAttemptCount(THREE_OR_MORE_ATTEMPTS),
  'efficiency-noAttemptTasksAttemptCount': `${PROCESSED_CALL_PREFIX}, одним из результатов: "Отменено клиникой", "Перенесено клиникой" и отсутствием звонков в рамках задания${WITH_SELECTED_FILTERS}`,
  'attemptDistribution-oneAttemptTargetTasksCount':
    targetResultByAttemptCount(ONE_ATTEMPT),
  'attemptDistribution-twoAttemptTargetTasksCount':
    targetResultByAttemptCount(TWO_ATTEMPTS),
  'attemptDistribution-threeAndMoreAttemptTargetTasksCount':
    targetResultByAttemptCount(THREE_OR_MORE_ATTEMPTS),
  'attemptDistribution-technicalTasksCount':
    processedWithResults(TECHNICAL_RESULTS),
  'attemptDistribution-oneAttemptTasksAttemptCount':
    targetCallsByAttemptCount(ONE_ATTEMPT),
  'attemptDistribution-twoAttemptTasksAttemptCount':
    targetCallsByAttemptCount(TWO_ATTEMPTS),
  'attemptDistribution-threeAndMoreAttemptTasksAttemptCount':
    targetCallsByAttemptCount(THREE_OR_MORE_ATTEMPTS),
  'attemptDistribution-negativeTasksAttemptCount': `${PROCESSED_CALL_PREFIX} и одним из результатов: ${TECHNICAL_RESULTS}${WITH_SELECTED_FILTERS}`,
  'failedReasons-notReceivedTasksCount': processedWithResult(
    'Не удалось дозвониться',
  ),
  'failedReasons-answeringMachineTasksCount':
    failedCallWithLastStatus('Автоответчик'),
  'failedReasons-noAnswerTasksCount': failedCallWithLastStatus('Нет ответа'),
  'failedReasons-errorTasksCount': failedCallWithLastStatus('Ошибка'),
  'failedReasons-hangUpTasksCount': failedCallWithLastStatus(
    'Сброс звонка абонентом',
  ),
  'failedReasons-notRecognizedTasksCount':
    failedCallWithLastStatus('Не распознана речь'),
  'failedReasons-notIdentifiedTasksCount':
    processedWithResult('Не идентифицирован'),
  'failedReasons-misCancelledTasksCount': processedWithResults(
    '"Отменено клиникой", "Перенесено клиникой"',
  ),
  'failedReasons-notReceivedAttemptCount': callsWithResult(
    'Не удалось дозвониться',
  ),
  'failedReasons-botDetectedAttemptCount': callsWithStatus('Автоответчик'),
  'failedReasons-noAnswerAttemptCount': callsWithStatus('Нет ответа'),
  'failedReasons-errorAttemptCount': callsWithStatus('Ошибка'),
  'failedReasons-hangUpAttemptCount': callsWithStatus('Сброс звонка абонентом'),
  'failedReasons-notRecognizedAttemptCount':
    callsWithStatus('Не распознана речь'),
  'failedReasons-notIdentifiedAttemptCount':
    callsWithResult('Не идентифицирован'),
  'failedReasons-misCancelledAttemptCount': `${PROCESSED_CALL_PREFIX}, одним из результатов: "Отменено клиникой", "Перенесено клиникой"${WITH_SELECTED_FILTERS}`,
  'interaction-confirmedTasksCount': processedWithResult('Подтверждено'),
  'interaction-slot-cancelledTotal': processedWithResults(
    '"Отказ", "Запрос на перенос", "Перенесено клиникой", "Отменено клиникой", "Передано оператору"',
  ),
  'interaction-slot-cancelledPatientAndClinic': processedWithResults(
    '"Отказ", "Отменено клиникой"',
  ),
  'interaction-cancelledTasksCount': processedWithResult('Отказ'),
  'interaction-waitingListTasksCount': processedWithResult('Лист ожидания'),
  'interaction-cancelledByClinicTasksCount':
    processedWithResult('Отменено клиникой'),
  'interaction-slot-rescheduledPatientAndClinic': processedWithResults(
    '"Запрос на перенос", "Перенесено клиникой"',
  ),
  'interaction-rescheduledTasksCount': processedWithResult('Запрос на перенос'),
  'interaction-rescheduledByClinicTasksCount': processedWithResult(
    'Перенесено клиникой',
  ),
  'interaction-operatorHandedTasksCount':
    processedWithResult('Передано оператору'),
  'interaction-notIdentifiedTasksCount':
    processedWithResult('Не идентифицирован'),
  'interaction-dispensarization-notReceivedTasksCount': processedWithResults(
    '"Не получен", "Не удалось дозвониться"',
  ),
  'interaction-notReceivedTasksCount': processedWithResult(
    'Не удалось дозвониться',
  ),
};

export const getOutgoingStatisticTooltip = (key: string): string | undefined =>
  OUTGOING_STATISTIC_TOOLTIPS[key];
